import { createReducer } from '@reduxjs/toolkit';
import { onFailure, onFulfill, onRequest } from '@common/utils/helpers/reducers';
import { authInitialState } from '@modules/current-user/store/auth';
import { registerRequestActions } from '@modules/current-user/actions';

export const registerRequestReducer = createReducer(authInitialState, {
  [registerRequestActions.REQUEST]: onRequest,
  [registerRequestActions.FAILURE]: onFailure,
  [registerRequestActions.FULFILL]: onFulfill,
  [registerRequestActions.SUCCESS]: (state) => {
    state.requestAction = 'register';
    return state;
  }
});
